export default __webpack_public_path__ + "static/baner-BMA-9d77a0c47f64feecdafb1aa2de5fc405.jpg";